import { ILinkCellRendererComponentOptions } from '@bssh/comp-lib/lib/components/data-table/link/link-cell-renderer.component';
import { ErrorMessages } from '../../core/utilities/error-messages';
import { RadLinkRendererBaseParams } from '@app/shared/cell-renderers/rad-link-renderer/rad-link-renderer.component';

export class DataTableUtilities {

    public static getLinkRenderer(value: any, href?: string, routerLinkParams?: any[], linkTarget?: string)  {

        const linkComponentParams: ILinkCellRendererComponentOptions = {
          value: value,
          href: href,
          routerLinkParams: routerLinkParams,
          target: linkTarget
        }
        return ({component: 'link', params: linkComponentParams});
      }
    
    public static getSpanRenderer(value?: any) {
        if (value) {
          return ({component: 'tooltip', params: { value }});
        }
    
        return ({component: 'span', params: { value: '---' }});
    }

    public static getDisabledHref(value: any, popoverTitle: string, popoverText?: string) {
        return {
                  component: 'popover',
                  params: {
                      popoverLabel: value,
                      popoverTitle,
                      isTextPopover: true,
                      popoverText: popoverText || ErrorMessages.NO_VIEW_PERMISSION_ERROR,
                  }
                };
    }

    public static getRadLinkParams(
      linkText: string, 
      linkUrl?: string, 
      tooltipText?: string, 
      target?: '_blank' | '_self',
      columnWidthReduction?: number
    ): RadLinkRendererBaseParams {
      return {
        linkText: linkText,
        linkUrl: linkUrl,
        tooltipText: tooltipText,
        target: target ? target :'_blank',
        columnWidthReduction: columnWidthReduction
      }
    }
}
